<template lang="pug">
  .signature
    title-bar {{ isVendor ? $t('查看签收单') : $t('下发签收单') }}
    .sigature_content(style="margin-left: 20px")
      el-row
        el-col(:span="4") {{ $t('供应商') }}
        el-col(:span="20") {{ signature.vendor_name_ch  + '/' + signature.vendor_name}}

      category(:data="signature.category_scope")

      template(v-if="!isVendor")
        contract-and-do-item(:item="item" :index="index" v-for="item, index in signature.contracts" :key="index")
      el-row(v-if="has_digital")
        el-col(:span="4") {{ $t('Buying Brief号') }}
        el-col(:span="10") {{ signature.buying_brief_no }}
      el-row(v-if="has_digital")
        el-col(:span="4") Buying Brief
        el-col(:span="10")
          a(
          :href="signature.buying_brief_download_url"
          style="overflow: hidden;white-space: nowrap;text-overflow: ellipsis;width: 100%;display: inline-block;"
          target="_blank"
          ) {{ signature.buying_brief_file_name }}
      el-row(v-if="signature.buying_brief_increment_file_name")
        el-col(:span="4") {{ $t('增量Buying Brief号') }}
        el-col(:span="10") {{ signature.buying_brief_increment_no }}
      el-row(v-if="signature.buying_brief_increment_file_name")
        el-col(:span="4") {{ $t('增量Buying Brief') }}
        el-col(:span="10")
          a(
            :href="signature.buying_brief_increment_download_url"
            style="overflow: hidden;white-space: nowrap;text-overflow: ellipsis;width: 100%;display: inline-block;"
            target="_blank"
          ) {{ signature.buying_brief_increment_file_name }}
      el-row
        el-col(:span="4") {{ $t('签收单') }}
        el-col(:span="20")
          a(
            v-if="signature.signature_url"
            :href="signature.signature_url"
            target="_blank"
          ) {{ signature.signature_name}}
          span(v-else) —
</template>

<script>
import axios from 'axios'
import TitleBar from '@/components/TitleBar'
import FooterButton from '@/components/FooterButton'
import Category from '@/components/Category'
import UploadFile from '@/components/UploadFile'
import ContractAndDoItem from '@/components/ContractAndDoItem'

export default {
  components: {
    TitleBar,
    Category,
    FooterButton,
    UploadFile,
    ContractAndDoItem
  },
  data () {
    return {
      signature: {
        contracts: []
      },
      has_digital: false
    }
  },
  computed: {
    isVendor () {
      return this.$store.state.common.user.is_vendor
    }
  },
  mounted () {
    this.fetchSignature()
    this.checkSubFinalScopeCategory()
  },
  methods: {
    async checkSubFinalScopeCategory () {
      try {
        const res = await axios.get('/management/subfinal/checkSubFinalScopeCategory', {
          params: {
            sub_final_scope_id: this.$store.state.campaign.subFinalScopeId
          }
        })
        this.has_digital = res.has_digital
      } catch (err) {
        throw new Error(err)
      }
    },
    fetchSignature () {
      axios.get('/management/subfinal/getSignature', {
        params: {
          sub_final_scope_id: this.$store.state.campaign.subFinalScopeId,
          servlet_path: this.$route.path
        }
      })
        .then(res => {
          this.signature = res
        })
    }
  }
}
</script>

<style lang="stylus">
.signature
  .footer-button
    padding-left 0px
</style>
